module.exports = __webpack_public_path__ + "media/svg-new/avatar-22 1-ae8bd89c.svg";